/**
 * 차트 카테고리 색상 팔레트 — 일기월장 디자인 시스템 정합 (2026-05-03)
 *
 * 철학 (Wanted DS Green):
 *   - 모노크롬 베이스 + 의미 있는 포인트 컬러
 *   - 그라데이션 / 형광색 / 의미 없는 컬러 태그 금지
 *   - 브랜드 그린이 액센트, 중립 cool 톤이 베이스
 *
 * 순서 의도:
 *   - 가장 큰/중요한 카테고리(첫 번째 슬라이스)일수록 채도 높은 브랜드 그린 사용
 *   - 7번째 이후는 톤이 반복되어도 디자인 시스템 안에서 일관됨
 *   - 12색까지 명도/색상 차이로 식별 가능
 *
 * 비고: Recharts SVG `fill`은 CSS 변수(`var(--xxx)`)를 일관되게 지원하지 않으므로
 * 디자인 토큰의 실제 hex 값을 직접 사용. designTokens.css와 동기화 유지 필요.
 */
export const CHART_PALETTE: readonly string[] = [
  '#00BF40', // 1. primary           — 브랜드 그린 (가장 큰 슬라이스)
  '#46474C', // 2. cool-900          — 강한 대비 (거의 블랙)
  '#FF9200', // 3. orange-600        — 따뜻한 액센트
  '#009632', // 4. primary-hover     — 딥 그린
  '#878A93', // 5. cool-700          — 중간 그레이
  '#FF4242', // 6. red-600           — 강조용 (지출 관련 시 의미적)
  '#7AE5A2', // 7. green-300         — 라이트 그린
  '#DBDCDF', // 8. cool-300          — 라이트 그레이
  '#006E25', // 9. primary-press     — 포레스트 그린
  '#B0F4C8', // 10. green-200        — 민트
  '#70737C', // 11. cool-800         — 슬레이트
  '#49E57D', // 12. green-500        — 비비드 그린
] as const;

/**
 * 카테고리 배열을 받아 카테고리명 → 색상 매핑을 생성.
 * 동일 카테고리는 항상 같은 색을 받도록 인덱스 기반 할당.
 */
export const generateCategoryColors = (
  categories: ReadonlyArray<string>,
): Record<string, string> => {
  const colors: Record<string, string> = {};
  categories.forEach((category, index) => {
    colors[category] = CHART_PALETTE[index % CHART_PALETTE.length];
  });
  return colors;
};

/**
 * 인덱스로 직접 색상을 가져올 때 사용.
 * (Cell 렌더 등에서 `CHART_PALETTE[index % CHART_PALETTE.length]` 패턴 단축)
 */
export const getChartColor = (index: number): string =>
  CHART_PALETTE[index % CHART_PALETTE.length];
